import Body from "./Components/Body";
import React from "react";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div >
      <Body/>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
